import api from "./Api";

class FaturamentoService {
  GetFaturamento(payload) {
    return api.get("/v1/faturamento/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFaturamento(payload) {
    return api.post("/v1/faturamento/", payload).then((response) => {
      return response.data;
    });
  }

  PutFaturamento(payload) {
    return api.put("/v1/faturamento/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFaturamento(payload) {
    return api.delete("/v1/faturamento/" + payload).then((response) => {
      return response.data;
    });
  }

  GetFaturamentoOData(payload) {
    return api.get("/OData/Faturamento" + payload).then((response) => {
      return response.data;
    });
  }

  Imprimir(payload) {
    return api
      .get("/v1/faturamento/Imprimir/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }
}

export default new FaturamentoService();
